

















































































































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import ReviewArea from "../../components/ReviewArea.vue";
import PreviewImageSidebar from "../../components/PreviewImageSidebar.vue";
import { BModal, BCarousel, BSidebar } from 'bootstrap-vue';
import { Sheet, SheetField, Examinee, SheetActivity, FieldActivity, ScoreOption, SearchCondition, ModalImageKindEnum, ReviewText, ReviewImage, AutoReviewTextTemplate, AutoReviewImageTemplate } from "../../modules/teacher/SaitenList";

export interface Data {
  sheet_id: string
  condition: SearchCondition
  sheet: Sheet | null
  sheetFields: SheetField[] | null
  allExaminees: Examinee[] | null
  examinees: Examinee[] | null
  autoReviewTextTemplates: AutoReviewTextTemplate[]
  autoReviewImageTemplates: AutoReviewImageTemplate[]
  studentCodeWidth: number
  studentNameWidth: number
  submittedAtWidth: number
  rightTableTdWidth: string
  colspan: number
  totalScoreAverage: number
  totalScoreRate: number
  totalFieldCount: number
  totalSaitenCompletedCount: number
  delayedJobCount: number
  isSaitenCompleted: boolean
  isStudentNoSortDesc: boolean
  isSubmittedAtSortDesc: boolean
  isTotalScoreSortDesc: boolean
  isFieldScoreSortDest: boolean
  modalExaminee: Examinee | null
  modalImageKind: number
  carouselPageIdx: number
  ModalImageKindEnum: Readonly<{Scan: number; Result: number;}>
  CorrectStateEnum: Readonly<{Seitou: number; Gotou: number; Tokuten: number;}>
  StudentSheetStatusEnum: Readonly<{Answering: number; SelfScoring: number; Scoring: number; Failure: number; Pass: number;}>
  windowHeight: number
  scoreOptions: ScoreOption[]
  errors: string[]
  isReviewImageVisible: boolean
  isAllCheckPublish: boolean
  isAllCheckSaitenTarget: boolean
  isAllCheckDownloadTarget: boolean
  isReviewOverlay: boolean
  reviewOverlayText: string
  previewScanImageExamineeId: number
  isScanImageVisible: boolean
  scanImageExamineeIds: number[]
  pcHelpFields: any[]
  tabletHelpFields: any[]
  isPdfDownloadSingleFile: boolean
  isFilterMisaiten: boolean
  dispSheetFieldIds: number[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "review-area": ReviewArea,
    "preview-image-sidebar": PreviewImageSidebar,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const modalReviewRef = ref<InstanceType<typeof BModal>>();
    const reviewAreaRef = ref<InstanceType<typeof ReviewArea>>();
    const sidebarReviewlImageRef = ref<InstanceType<typeof BSidebar>>();
    const previewScanImageSidebarRef = ref<InstanceType<typeof PreviewImageSidebar>>();
    const pdfDownlaodModalRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      condition: new SearchCondition(),
      sheet: null,
      sheetFields: new Array<SheetField>(),
      allExaminees: new Array<Examinee>(),
      examinees: new Array<Examinee>(),
      autoReviewTextTemplates: [],
      autoReviewImageTemplates: [],
      studentCodeWidth: 90,
      studentNameWidth: 0,
      submittedAtWidth: 145,
      rightTableTdWidth: "",
      colspan: 4,
      totalScoreAverage: 0,
      totalScoreRate: 0,
      totalFieldCount: 0,
      totalSaitenCompletedCount: 0,
      delayedJobCount: 0,
      isSaitenCompleted: false,
      isStudentNoSortDesc: false,
      isSubmittedAtSortDesc: false,
      isTotalScoreSortDesc: false,
      isFieldScoreSortDest: false,
      modalExaminee: null,
      modalImageKind: ModalImageKindEnum.Scan,
      CorrectStateEnum: Common.CorrectStateEnum,
      ModalImageKindEnum: ModalImageKindEnum,
      StudentSheetStatusEnum: Common.StudentSheetStatusEnum,
      carouselPageIdx: 0,
      windowHeight: 0,
      scoreOptions: new Array<ScoreOption>(),
      errors: [],
      isReviewImageVisible: false,
      isAllCheckPublish: false,
      isAllCheckSaitenTarget: false,
      isAllCheckDownloadTarget: false,
      isReviewOverlay: false,
      reviewOverlayText: "",
      previewScanImageExamineeId: null,
      isScanImageVisible: false,
      scanImageExamineeIds: [],
      pcHelpFields: [
        { key: "Tキー + クリック", img: require("@/assets/images/keyboard_T.png"), description: "テキストを出力" },
        { key: "テキスト選択中にBackSpaceキー", img: require("@/assets/images/keyboard_Backspace.png"), description: "テキストを削除" },
        { key: "答案上を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        { key: "Dキー + マウス", img: require("@/assets/images/keyboard_D.png"), description: "自由線" },
        { key: "Eキー + マウス", img: require("@/assets/images/keyboard_E.png"), description: "消しゴム" },
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "答案上を長押し", description: "長押しした場所にテキストを出力" },
        { key: "テキストを長押し", description: "長押ししたテキストを削除" },
        // { key: "ピンチイン・ピンチアウト", description: "用紙の拡大縮小<br>（手書きモードで設問青枠内では使用できません）" },
      ],
      isPdfDownloadSingleFile: false,
      isFilterMisaiten: false,
      dispSheetFieldIds: [],
    });

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      state.windowHeight = windowHeight;

      if(tableArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop - 2) + "px";
      }
    };

    /************************************************************
     * モーダルの高さ
     ************************************************************/

    const modalHeight = computed((): any => {
      return state.windowHeight - 200;
    });

    /************************************************************
     * 公開列表示判定
     ************************************************************/

    const isPublishColumnVisible = computed((): boolean => {
      return !context.root.$store.getters.isApprovalExamSheetType || context.root.$store.getters.isOptionExamManualPublishActive;
    });

    /************************************************************
     * テーブルスクロールイベント
     ************************************************************/

    const scrollChanged = () => {
      const topRightTableArea: Element = document.getElementById("top-right-table-area");
      const bottomLeftTableArea: Element = document.getElementById("bottom-left-table-area");
      const bottomRightTableArea: Element = document.getElementById("bottom-right-table-area");

      topRightTableArea.scrollLeft = bottomRightTableArea.scrollLeft;
      bottomLeftTableArea.scrollTop = bottomRightTableArea.scrollTop;
    };

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 画像作成ボタン押下
     ************************************************************/

    const createPdfJob = async () => {
      if(!window.confirm("採点画像作成を実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/teacher/saiten_list/create_pdf_job/${state.sheet_id}`).then(response => {
        alert("採点画像作成を開始しました");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 出席番号列でソート
     ************************************************************/

    const sortStudentNo = () => {
      state.isStudentNoSortDesc = !state.isStudentNoSortDesc;
      if(state.isStudentNoSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.student_code > b.student_code ? 1 : -1).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.student_code > b.student_code ? 1 : -1);
      }
    }

    /************************************************************
     * 提出日列でソート
     ************************************************************/

    const sortSubmittedAt = () => {
      state.isSubmittedAtSortDesc = !state.isSubmittedAtSortDesc;
      if(state.isSubmittedAtSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.submitted_at_plane_text > b.submitted_at_plane_text ? 1 : -1).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.submitted_at_plane_text > b.submitted_at_plane_text ? 1 : -1);
      }
    }

    /************************************************************
     * 合計得点列でソート
     ************************************************************/

    const sortTotalScore = () => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => a.score - b.score).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => a.score - b.score);
      }
    };

    /************************************************************
     * 設問列でソート
     ************************************************************/

    const sortFieldScore = (idx: number) => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b)).reverse();
      }else{
        state.examinees = state.examinees.sort((a, b) => sortFieldScoreSub(idx, a, b));
      }
    };

    /************************************************************
     * 設問列のソートロジック 得点でソートする
     * 誤答・未採点・欠席者を区別するため
     * ダミー特典として未採点は-1、欠席者は-2でソートする
     ************************************************************/

    const sortFieldScoreSub = (idx: number, e1: Examinee, e2: Examinee) => {
      let scoreA = 0, scoreB = 0;
      if(e1.fieldActivities.length > idx){
        scoreA = e1.fieldActivities[idx].score == null ? -1 : e1.fieldActivities[idx].score;
      }else{
        scoreA = -2;
      }
      if(e2.fieldActivities.length > idx){
        scoreB = e2.fieldActivities[idx].score == null ? -1 : e2.fieldActivities[idx].score;
      }else{
        scoreB = -2;
      }
      return scoreA - scoreB;
    }

    /************************************************************
     * モーダル種別に応じた答案or採点結果画像base64を返却
     ************************************************************/

    const base64Images = computed((): string[] => {
      if(state.modalExaminee == null){
        return [];
      }else if(state.modalImageKind == state.ModalImageKindEnum.Scan){
        return state.modalExaminee.base64ScanImages;
      }else{
        return state.modalExaminee.base64ResultImages
      }
    });

    /************************************************************
     * モーダルのtitleを返却
     ************************************************************/

    const modalTitle = computed((): string => {
      if(state.modalExaminee == null){
        return "";
      }
      
      if(state.modalImageKind == state.ModalImageKindEnum.Scan){
        return `答案画像　生徒CD：${state.modalExaminee.student_code}`;
      }else{
        return `採点結果　生徒CD：${state.modalExaminee.student_code}`;
      }
    });

    /************************************************************
     * 講評画像表示
     ************************************************************/

    const showReviewImage = async (examinee: Examinee) => {
      await initializeReviewExaminee(examinee);
      state.modalExaminee = examinee;
      state.isReviewImageVisible = true;
      // reviewAreaRef.value.errors = [];
    };

    /************************************************************
     * 講評画像クローズ
     ************************************************************/

    const hiddenReviewImage = () => {
      state.isReviewImageVisible = false;
    }

    /************************************************************
     * 講評モーダルの表示対象画像初期化
     ************************************************************/

    const initializeReviewExaminee = async (examinee: Examinee) => {
      
      // 採点結果画像未DLの場合はDL実行
      if(examinee.base64ResultImages.length == 0){
        
        // 採点結果画像DL
        state.isReviewOverlay = true;
        state.reviewOverlayText = "画像データ取得中... しばらくお待ちください。";
        const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
        await http.get(`/api/teacher/saiten_list/download_result_image/${state.sheet_id}/${sheetActivityIds}`).then(response => {
          response.data.base64_images.forEach((x: string) => {
            examinee.base64ResultImages.push(x);
          });

          examinee.sheetActivities.forEach((sheetActivity, i) => {
            const reviewTexts: ReviewText[] = response.data.review_texts.filter((x: ReviewText) => x.sheet_activity_id == sheetActivity.id);
            sheetActivity.reviewTexts = reviewTexts;
            const reviewImages: ReviewImage[] = response.data.review_images.filter((x: ReviewImage) => x.sheet_activity_id == sheetActivity.id);
            sheetActivity.reviewImages = reviewImages;
            sheetActivity.idx = reviewTexts.length == 0 ? 0 : reviewTexts.map(x => x.idx).reduce((a,b)=>Math.max(a,b)) + 1;
            sheetActivity.base64Canvas = response.data.base64_canvases[i];
          });
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
        state.isReviewOverlay = false;
      }
    }

    /************************************************************
     * 講評モーダルの表示対象生徒切り替え
     * ReviewAreaからemitで呼ばれる
     ************************************************************/

    const changeReviewExaminee = async (examinee: Examinee, addCount: number) => {
      
      const reviewExaminees = state.examinees.filter(x => x.result_image_created)

      const idx = reviewExaminees.indexOf(examinee) + addCount;
      
      if(idx < 0 || idx >= reviewExaminees.length){
        return;
      }

      const newExaminee = reviewExaminees[idx];
      await initializeReviewExaminee(newExaminee);
      state.modalExaminee = newExaminee;
    }

    /************************************************************
     * 講評コメント更新
     ************************************************************/

    const updateReview = async (param: object) => {

      state.isReviewOverlay = true;
      state.reviewOverlayText = "処理実行中... しばらくお待ちください。";

      await http.post(`/api/teacher/saiten_list/update_review`, param).then(response => {
        Common.showToast(context.root.$bvToast, "保存処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          reviewAreaRef.value.errors = error.response.data.errors;
        }else{
          reviewAreaRef.value.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      // ステータス最新にするために再検索
      await search();

      const examieeId = state.modalExaminee.id;
      const modalExaminee = state.examinees.filter(x => x.id == examieeId);
      if(modalExaminee){
        await initializeReviewExaminee(modalExaminee[0]);
        state.modalExaminee = modalExaminee[0];
      }else{
        modalReviewRef.value.hide();
      }

      state.isReviewOverlay = false;
    }

    /************************************************************
     * 画像モーダル表示
     ************************************************************/

    const showModalImage = async (examinee: Examinee, imageKind: number) => {

      if((imageKind == state.ModalImageKindEnum.Scan && examinee.base64ScanImages.length == 0)
        || (imageKind == state.ModalImageKindEnum.Result && examinee.base64ResultImages.length == 0)){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadScanImage(examinee, imageKind)
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      state.modalExaminee = examinee;
      state.modalImageKind = imageKind;
      state.carouselPageIdx = 0;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadScanImage = async (examinee: Examinee, imageKind: number) => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const sheetActivityIds = examinee.sheetActivities.map(x => x.id);
      await http.get(`/api/teacher/saiten_list/download_scan_image/${state.sheet_id}/${sheetActivityIds}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          if(imageKind == state.ModalImageKindEnum.Scan){
            examinee.base64ScanImages.push(x);
          }else{
            examinee.base64ResultImages.push(x);
          }
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.sheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.sheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx - 1; i >= 0; i--){
        const examinee = state.examinees[i];
        if((state.modalImageKind == state.ModalImageKindEnum.Scan && examinee.base64ScanImages.length == 0)
          || (state.modalImageKind == state.ModalImageKindEnum.Result && examinee.base64ResultImages.length == 0)){
          // 画像をダウンロード
          const isSuccess: boolean = await downloadScanImage(examinee, state.modalImageKind)
          if(!isSuccess){
            // ダウンロード失敗は処理終了
            return;
          }
        }
        state.modalExaminee = examinee;
        carouselRef.value.setSlide(state.carouselPageIdx);
        break;
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      const idx = state.examinees.indexOf(state.modalExaminee);
      for(let i = idx + 1; state.examinees.length; i++){
        const examinee = state.examinees[i];
        if((state.modalImageKind == state.ModalImageKindEnum.Scan && examinee.base64ScanImages.length == 0)
          || (state.modalImageKind == state.ModalImageKindEnum.Result && examinee.base64ResultImages.length == 0)){
          // 画像をダウンロード
          const isSuccess: boolean = await downloadScanImage(examinee, state.modalImageKind)
          if(!isSuccess){
            // ダウンロード失敗は処理終了
            return;
          }
        }
        state.modalExaminee = examinee;
        carouselRef.value.setSlide(state.carouselPageIdx);
        break;
      }
    };

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertSubmittedAt = (date: string) => {
      return date ? moment(date).format('Y年M月D日') : "-";
    };

    /************************************************************
     * ダウンロードヘッダチェックボックス変更イベント
     ************************************************************/

    const allSelectChanged = (changedVal: boolean) => {
      state.examinees.forEach(x => {
        x.checked = changedVal;
      });
    };

    /************************************************************
     * ダウンロードアイコン押下
     ************************************************************/

    const downloadPdf = async () => {

      const studentIds = state.examinees.filter(x => x.isDownloadTarget).map(x => x.student_no);
      if(studentIds.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("PDFをダウンロードします。よろしいですか？")){
        return;
      }

      pdfDownlaodModalRef.value.hide();

      const param = {
        student_ids: studentIds
      }

      const apiName = state.isPdfDownloadSingleFile ? "download_pdf_single" : "download_pdf_multi";

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_list/${apiName}/${state.sheet_id}`, param, {responseType: 'arraybuffer'}).then(response => {
        if(state.isPdfDownloadSingleFile){
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `採点結果画像_${state.sheet.name}.pdf`;
          a.click();
        }else{
          const blob = new Blob([response.data], { type: 'application/zip' });
          const a = document.createElement('a');
          a.href = window.URL.createObjectURL(blob);
          a.download = `採点結果画像_${state.sheet.name}.zip`;
          a.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * ペンシルアイコン押下 採点画面へ遷移
     ************************************************************/

    const saitenStart = (sheetField: SheetField) => {

      const examineeIds = state.examinees.filter(x => x.isSaitenTarget).map(x => x.id);

      if(examineeIds.length == 0){
        alert("表示対象の生徒が選択されていません。");
        return;
      }

      context.root.$store.commit("setSaitenTargetExamineeIds", examineeIds);

      if(sheetField.scoring_type == Common.ScoringTypeEnum.Seigo){
        context.root.$router.push(`/teacher_site/saiten_input_seigo/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }else if(Common.IsScoringTypeScoreStamp(sheetField.scoring_type)){
        context.root.$router.push(`/teacher_site/saiten_input_score_stamp/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }
    }

    /************************************************************
     * 一枚採点アイコン押下 一枚採点画面へ遷移
     ************************************************************/

    const saitenStartIchimai = (examinee: Examinee) => {
      context.root.$router.push(`/teacher_site/saiten_input_ichimai/${state.sheet_id}/${examinee.id}`).catch(err => {});
    }

    /************************************************************
     * 配点プルダウン変更
     ************************************************************/

    const allotChanged = async (sheetField: SheetField) => {

      if(!window.confirm("配点を変更しますか？")){
        sheetField.allot = sheetField.allotCache;
        return;
      }
      const param: object = {
        sheet_field_idx: state.sheetFields.indexOf(sheetField),
        allot: sheetField.allot
      };

      await http.post(`/api/teacher/saiten_list/update_allot/${state.sheet.base_sheet_id}`, param).then(response => {
        alert("配点の変更が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * 絞り込み条件クリア
     ************************************************************/

    const clearCondition = () => {
      state.condition = new SearchCondition();
    }

    /************************************************************
     * 絞り込みボタン押下
     ************************************************************/

    const searchByButton = async () => {
      context.root.$store.commit("setSaitenTargetExamineeIds", []);
      await search();
    }

    /************************************************************
     * 検索API
     ************************************************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/saiten_list?${Common.BuildQuery(state.condition, 'search_sheet')}&sheet_id=${state.sheet_id}`).then(async response => {
        
        context.root.$store.commit("setSheetType", response.data.sheet_type);

        const fontDocument = document as Document & {fonts?: {ready: Promise<void>}};
        if(fontDocument.fonts){
          await fontDocument.fonts.ready;
        }

        state.sheet = new Sheet(response.data.sheet);
        state.delayedJobCount = response.data.create_pdf_job_count

        const fieldActivities: FieldActivity[] = response.data.field_activities.map((x: any) => new FieldActivity(x));
        const sheetActivities: SheetActivity[] = response.data.sheet_activities.map((x: any) => new SheetActivity(x));
        state.examinees = response.data.examinees.map((x: any, i: any) => new Examinee(x, sheetActivities, fieldActivities, i + 1, context.root.$store.state.saitenTargetExamineeIds, context.root.$store.state.sheet_type, context.root.$store.getters.isOptionExamManualPublishActive));
        
        state.examinees.forEach(examinee => {
          if(examinee.saitenCompleted && examinee.score < state.sheet.passing_score){
            examinee.isFailure = state.examinees.filter(x => x.student_code == examinee.student_code && x.times > examinee.times && x.saitenCompleted && x.score >= state.sheet.passing_score).length == 0;
          }
        });
        
        state.sheetFields = response.data.sheet_fields.map((x: any) => new SheetField(x, fieldActivities));

        let totalScore = Common.sumArray(state.examinees.map(x => x.score));
        const totalAllot = state.sheet.allot * state.examinees.length;
        state.totalScoreAverage = state.examinees.length > 0 ? Number((totalScore / state.examinees.length).toFixed(1)) : 0;
        state.totalScoreRate = state.examinees.length > 0 ? Math.round(totalScore / totalAllot * 100) : 0;
        state.totalFieldCount = state.sheetFields.length * state.examinees.length;
        state.totalSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.saitenCompletedCount));
        state.isSaitenCompleted = state.totalSaitenCompletedCount == state.totalFieldCount;

        const canvasContext = document.createElement("canvas").getContext("2d");
        const fontFamily = window.getComputedStyle(document.body).fontFamily;

        const studentNameWidth = state.examinees.length > 0 ? state.examinees.map(x => !x.student_name ? 0 : Common.calculateTextWidth(x.student_name)).reduce((a,b)=>Math.max(a,b)) + 10 : 0;
        state.studentNameWidth = Math.min(Math.max(studentNameWidth, 65), 164);

        // 提出日の表示文字列とヘッダのうち、必要な横幅が大きい方を列幅に設定
        if(canvasContext){
          canvasContext.font = `14px ${fontFamily}`;
          const submittedAtTextWidth = state.examinees.length > 0 ? state.examinees.map(x => canvasContext.measureText(x.submitted_at).width).reduce((a,b)=>Math.max(a,b)) : 0;
          canvasContext.font = `12px ${fontFamily}`;
          // ヘッダはソートアイコン16pxと間隔4px、列全体は左右の内側余白と罫線10pxを加算
          const submittedAtHeaderWidth = canvasContext.measureText("提出日").width + 20;
          state.submittedAtWidth = Math.ceil(Math.max(submittedAtTextWidth, submittedAtHeaderWidth)) + 10;
        }

        let rightTableTdWidth = 0;
        state.sheetFields.forEach(sheetField => {
          const fieldName = [sheetField.part1, sheetField.part2, sheetField.part3].filter(x => x != null && x != "").join(" ");
          const fieldWidth = Common.calculateTextWidth(fieldName);
          if(fieldWidth > rightTableTdWidth){
            rightTableTdWidth = fieldWidth;
          }
        });

        rightTableTdWidth = rightTableTdWidth > 80 ? rightTableTdWidth : 80;

        // 文字幅から計算した列幅に左右の内側余白と罫線を追加
        rightTableTdWidth += 10;

        state.rightTableTdWidth = `${rightTableTdWidth}px`;

        // ボディで確定した生徒CD列幅をヘッダへ反映
        await context.root.$nextTick();
        const studentCodeCell = document.querySelector<HTMLElement>("#bottom-left-table-area tbody tr:first-child td:first-child");
        if(studentCodeCell){
          state.studentCodeWidth = studentCodeCell.offsetWidth;
          await context.root.$nextTick();
        }

        for(let i = 1; i <= 100; i++){
          state.scoreOptions.push(new ScoreOption(i, `${i}点`));
        }

        state.scanImageExamineeIds = state.examinees.map(x => x.id);

        state.autoReviewTextTemplates = response.data.auto_review_text_templates;
        state.autoReviewImageTemplates = response.data.auto_review_image_templates;

        context.root.$store.commit("setSaitenListCondition", state.condition);
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 表示全件切り替え
     ************************************************************/

    const checkAllSaitenTarget = (isChecked: boolean) => {
      state.examinees.forEach(x => x.isSaitenTarget = isChecked);
    }

    /************************************************************
     * 公開全件切り替え
     ************************************************************/

    const checkAllPublish = (isChecked: boolean) => {
      state.examinees.filter(x => x.is_publish != null).forEach(x => x.is_publish = isChecked);
    }

    /************************************************************
     * 表示対象設問のidリスト取得
     ************************************************************/

    const setDispSheetFieldIds = () => {
      if(state.isFilterMisaiten){
        state.dispSheetFieldIds = state.sheetFields.filter(x => !x.isSaitenCompleted).map(x => x.id);
      }else{
        state.dispSheetFieldIds = state.sheetFields.map(x => x.id);
      }
    }

    /************************************************************
     * 未採点のみ表示チェックボックスの変更監視
     ************************************************************/

    watch(() => state.isFilterMisaiten, (newVal, oldVal) => {
      setDispSheetFieldIds();
      context.root.$store.commit("setIsFilterMisaiten", newVal);
    });

    /************************************************************
     * PDFダウンロード対象全件切り替え
     ************************************************************/

     const checkAllDownload = (isChecked: boolean) => {
      state.examinees.filter(x => x.result_image_created).forEach(x => x.isDownloadTarget = isChecked);
    }

    /************************************************************
     * 公開状態更新
     ************************************************************/

    const updatePublish = async () => {
      const examinees = state.examinees.filter(x => x.is_publish != null && x.is_publish != x.is_publish_cache);

      if(examinees.length == 0){
        alert("公開状態が変更されていません。");
        return;
      }

      if(!window.confirm("公開状態を更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/saiten_list/update_publish`, {sheet_id: state.sheet_id, examinees: examinees}).then(response => {
        state.examinees.forEach(x => x.is_publish_cache = x.is_publish);
        alert("処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      state.sheet_id = context.root.$route.params.sheet_id;
      state.condition = context.root.$store.state.saitenListCondition;

      await search();
      
      adjustHeight();

      if(context.root.$store.state.isFilterMisaiten == null){
          // 試験一覧から遷移 未採点のみ表示チェックボックスの初期値設定
          if(state.isSaitenCompleted || !context.root.$store.getters.isCompareFinal){
            context.root.$store.commit("setIsFilterMisaiten", false);
          }else{
            context.root.$store.commit("setIsFilterMisaiten", true);
          }
        }else{
          // 採点画面から遷移 基本は遷移前のチェック状態を使用するが
          // チェックONで採点画面へ遷移⇒全問採点完了して採点一覧に戻ってきた場合はチェックを外す
          if(state.isSaitenCompleted){
            context.root.$store.commit("setIsFilterMisaiten", false);
          }
        }

        state.isFilterMisaiten = context.root.$store.state.isFilterMisaiten;

        setDispSheetFieldIds();

      window.addEventListener("resize", adjustHeight);
      document.getElementById("bottom-right-table-area").onscroll = scrollChanged;
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    /******************************
     * 氏名の省略表示判定
     ******************************/

    const isStudentNameTruncated = (studentName: string) => {
      return studentName != null && Common.calculateTextWidth(studentName) > state.studentNameWidth - 10;
    }

    const showScanImage = (examinee: Examinee) => {
      state.previewScanImageExamineeId = examinee.id;
      state.isScanImageVisible = true;
    }

    const SheetTypeEnum = Common.SheetTypeEnum;

    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      modalReviewRef,
      reviewAreaRef,
      sidebarReviewlImageRef,
      previewScanImageSidebarRef,
      pdfDownlaodModalRef,
      convertExecDateText,
      createPdfJob,
      sortStudentNo,
      sortTotalScore,
      sortFieldScore,
      base64Images,
      modalTitle,
      showModalImage,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      allSelectChanged,
      downloadPdf,
      saitenStart,
      saitenStartIchimai,
      allotChanged,
      convertSubmittedAt,
      search,
      clearCondition,
      showReviewImage,
      hiddenReviewImage,
      modalHeight,
      isPublishColumnVisible,
      changeReviewExaminee,
      updatePublish,
      checkAllPublish,
      checkAllSaitenTarget,
      searchByButton,
      updateReview,
      sortSubmittedAt,
      showScanImage,
      isStudentNameTruncated,
      SheetTypeEnum,
      checkAllDownload,
    };
  }
})
